import { render, staticRenderFns } from "./ShopSubsidyRecord.vue?vue&type=template&id=0ccaefb8&scoped=true"
import script from "./ShopSubsidyRecord.vue?vue&type=script&lang=js"
export * from "./ShopSubsidyRecord.vue?vue&type=script&lang=js"
import style0 from "./ShopSubsidyRecord.vue?vue&type=style&index=0&id=0ccaefb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccaefb8",
  null
  
)

export default component.exports